import type { ChatRoom } from './types';

function lastMessageTime(room: ChatRoom): number {
  const t = room.last_message?.created_at;
  if (!t) return 0;
  const ms = Date.parse(t);
  return Number.isFinite(ms) ? ms : 0;
}

function pickNewerLastMessage(prev: ChatRoom, incoming: ChatRoom): ChatRoom['last_message'] {
  const prevLm = prev.last_message;
  const incLm = incoming.last_message;
  if (!incLm) return prevLm;
  if (!prevLm) return incLm;
  return lastMessageTime(incoming) >= lastMessageTime(prev) ? incLm : prevLm;
}

function mergeRoomFields(prev: ChatRoom, incoming: ChatRoom): ChatRoom {
  const name =
    (incoming.name && String(incoming.name).trim()) ||
    (prev.name && String(prev.name).trim()) ||
    incoming.name ||
    prev.name;
  const avatar_url = incoming.avatar_url ?? prev.avatar_url;
  const direct_peer_user_id =
    incoming.direct_peer_user_id ?? prev.direct_peer_user_id ?? null;

  return {
    ...prev,
    ...incoming,
    name,
    avatar_url,
    direct_peer_user_id,
    last_message: pickNewerLastMessage(prev, incoming),
  };
}

/** Merge API room list with store: keep display fields when API returns blanks. */
export function mergeChatRoomList(incoming: ChatRoom[], prev: ChatRoom[]): ChatRoom[] {
  if (!Array.isArray(incoming) || incoming.length === 0) {
    return Array.isArray(incoming) ? incoming : [];
  }
  const prevById = new Map(prev.map((r) => [r.id, r]));
  return incoming.map((room) => {
    const old = prevById.get(room.id);
    return old ? mergeRoomFields(old, room) : room;
  });
}
